<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="language">





<div class="grid">
<div class="col-12 md:col-3">
<div class="content_card_content">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.dil" :value="language.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.kod" :value="language.code" valkey="code" @dataChanged="dataChanged"></ClickEditInputText>


<Divider />
</div>
</div>


<div class="col-12 md:col-9">
<div class="content_card_content ">

<Toolbar class="contenttopbar">
<template #start>
<h3 class="text-primary mb-2 mt-2 font-medium">{{language.name}} {{$store.state.languages.lang_phrases.terimleri}}</h3>
</template>
<template #end>

<Button  class="p-button-primary p-button-outlined p-button-sm mr-2 pr-5 pl-2 w-full" :label="$store.state.languages.lang_phrases.klonla" icon="pi pi-plus"  />
 <Dropdown v-model="selected_section" :options="sections"  optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" @change="setSelectedPhrases(selected_section)" />


</template>
</Toolbar>

<div class="pb-8 mb-4">
<SelectedPhrases  v-for="item in selected_phrases" :key="item.id" :phrase="item" @phraseUpdated="phraseUpdated"></SelectedPhrases>


<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newAdded"></ClickAddInputText>
</div>
</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
import SelectedPhrases from "./SelectedPhrases"
export default {

  name: 'Language',
  components:{SelectedPhrases},
  data () {
    return {
      language:null,
      phrases:[],
      sections: [
          {
              name: this.$store.state.languages.lang_phrases.hepsi,
              id: 'all',
          },
          {
              name: 'Admin Arayüzü',
              id: 'admin',
          },
          {
              name: 'Müşteri Arayüzü',
              id: 'general',
          },
      ],
      selected_section:"all",
      selected_phrases:[],

    }
  },
  mounted()
  {
    //this.$store.dispatch('ui/setActiveTab',1) 
    this.getData()
  },
  methods:{
    setSelectedPhrases(section)
    {
      console.log(section)
      let items = []
      if(section!=="all")
      {
       items = this.phrases.filter((item)=>{return item.section == section})
      }
      else
      {
         items = this.phrases
      }
      this.selected_phrases = items
      console.log("selected_phrases")
      console.log(this.selected_phrases)
    },
    newAdded(data)
    {

      let formdata = new FormData()
      formdata.append("original",data.value)
      formdata.append("language_id",this.language.id) 
      formdata.append("section",this.selected_section)      
      this.generalSubmission(formdata,"language/add_phrase",this.afternewAdded)
    },
    afternewAdded(response)
    {
      console.log(response.data)
      this.phrases.push(response.data)
      this.setSelectedPhrases(this.selected_section)

    },
    phraseUpdated(phrase)
    {
      console.log("phrase")
      console.log(phrase.id)
      console.log( this.phrases[0].id)
      
      let ind = this.phrases.findIndex((item)=>{return item.id == phrase.id})
      console.log(ind)
      this.phrases[ind] = phrase
      this.setSelectedPhrases(this.selected_section)

    },
  	async getData()
    {
        let data = await this.generalApiGet("language/"+this.$route.params.id)
        await console.log(data)
        this.phrases = await data.phrases
        this.setSelectedPhrases("all")
        this.language = await data.language
        let title = process.env.VUE_APP_TITLE || "Verify"
        document.title = data.language.name+" - "+title || title;
    },
     dataChanged(data)
    {
      console.log("dataChanged lang")
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"language/"+this.language.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response.data);
      if(response.data.status && response.data.status !==200)
      {
        
      }
      else
      {
        this.language = response.data
      }
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>